import React, {
  Component
} from 'react';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import * as Config from '../../config/Config';
import * as Common from '../../helpers/Common';


export default class SelectLearnerObserver extends Component {

  constructor(props) {
    super(props);
    this.state = {
     ActiveObservers:[],
     checkedValues:[],
     pageOfItems:[],
     checkedmails:[]
    };
    this.onRowSelect=this.onRowSelect.bind(this);
     this.onSelectAll = this.onSelectAll.bind(this);
  }



    onRowSelect(row, isSelected){

   // alert(isSelected);
    let  email = row['assessor_id'];
    //this.getSelectedRowKeys(email);
    if(isSelected == true){

    	 //this.setState({checkedmails: this.state.checkedmails.concat([email])});
    	 var joined = this.state.checkedmails.concat(email);
  	 this.setState({ checkedmails: joined })

    }
    else if(isSelected== false){
   //  	this.setState({
  	//   data: update(this.state.data, {$splice: [[index, 1]]})
  	// })
  	 var array = this.state.checkedmails;
  	  var index = array.indexOf(email)
  	  array.splice(index, 1);
  	  this.setState({checkedmails: array });

  	// var joined = this.state.checkedmails.filter(function(email) { return user.id != member.id });
  	// this.setState({ users: users });
       //alert(this.state.checkedmails);
    }


  }

  onSelectAll(isSelected, currentDisplayAndSelectedData){
    // alert("is select all: " + isSelected);
    // alert("Current display and selected data: ");
    if(isSelected == true){
    	var mails = this.state.checkedmails;
  	  for(let i=0;i<currentDisplayAndSelectedData.length;i++){
  	     //alert(currentDisplayAndSelectedData[i]['email']);
  	     let  email  = currentDisplayAndSelectedData[i]['assessor_id'];
  	     //alert(email);
  	     let mail  = mails.push(email);
  	     //alert(mail);
  	     //let mail = mail.join(',');

  	  }
  	   this.setState({ mails })
  		//alert(this.state.checkedmails);

    }
    else if(isSelected== false){
   //  	this.setState({
  	//   data: update(this.state.data, {$splice: [[index, 1]]})
  	// })
  	var array = this.state.checkedmails;
  	 for(let i=0;i<currentDisplayAndSelectedData.length;i++){
  	     //alert(currentDisplayAndSelectedData[i]['email']);
  	     let  email  = currentDisplayAndSelectedData[i]['assessor_id'];
  	     //alert(email);
  	    var index = array.indexOf(email)
  	 	 array.splice(index, 1);


  	  }


  	  this.setState({checkedmails: array });

    }
  }


  getActiveObserver(){
    let learnerID = Common.getUserData("id", true);
    let corporateID = Common.getUserData("corporateID", true);
    let productID = Common.getUserData("productID", true);
    Common.reactLoader("show", "Please wait...");
    fetch(Config.domainUrl+'personal/observers-view', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization':'Bearer ' +Common.getTokenData()
        },
        body: JSON.stringify({
            learner_id:learnerID,corporateID:corporateID,productID:productID
        })
    }).then((response) => response.json()).then((responseJson) => {
        Common.reactLoader("hide");
        if(responseJson.status != 0){
          this.setState({
            ActiveObservers : responseJson.actyetact[0].activeob
          });
        }
    });
  }

  submitObserverandProceed(){
    if(this.state.checkedmails.length==0){
      Common.message('Attention','You have to select atleast one Observer','warning');
    }else{
      this.props.submitObserverandProceed(this.state.checkedmails);
    }
  }

  componentDidMount(){ this.getActiveObserver(); }

  render() {
    const selectRowProp = {
      mode: 'checkbox',
      clickToSelect: true,
      onSelect: this.onRowSelect,
      onSelectAll: this.onSelectAll
    };
    var options = {
      noDataText: 'You have no Active Observers.'
    };

    return (
      <div>
        <div className="observer">
          <h3 className="title_assessors">Observers</h3>
          <BootstrapTable data={ this.state.ActiveObservers } containerClass="myjourney-table"  ref="table" selectRow={ selectRowProp } options={options} >
            <TableHeaderColumn hidden={true} dataField='assessor_id' isKey>Observer Name</TableHeaderColumn>
            <TableHeaderColumn dataField='name' >Observer Name</TableHeaderColumn>
            <TableHeaderColumn dataField='relationship'>Relationship</TableHeaderColumn>
            <TableHeaderColumn dataField='email'>Email ID</TableHeaderColumn>
            <TableHeaderColumn dataField='contact'>Contact No</TableHeaderColumn>
          </BootstrapTable>
        </div>
        <div id="Active">
          <input onClick={(e)=>this.submitObserverandProceed()} value="Continue" alt="Continue" title="Continue" className="button_org mail-icon" type="button" style={{float:"right"}} />
        </div>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/lr_dlr_components/partials/SelectLearnerObserver.js